"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentUser = exports.CurrentUserProvider = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const current_user_graphql_1 = require("./current-user.graphql");
const AccountContext_1 = require("contexts/AccountContext");
const initialState = {
    currentUser: null
};
const UserContext = (0, react_1.createContext)(initialState);
const CurrentUserProvider = ({ children }) => {
    const { account } = (0, AccountContext_1.useAccount)();
    const { data } = (0, client_1.useQuery)(current_user_graphql_1.GET_USER, {
        // only request current user data if the account is logged in
        skip: !(account === null || account === void 0 ? void 0 : account.id)
    });
    const [currentUser, setCurrentUser] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (data && data.currentUser) {
            setCurrentUser(data.currentUser);
        }
    }, [data]);
    return (react_1.default.createElement(UserContext.Provider, { value: { currentUser } }, children));
};
exports.CurrentUserProvider = CurrentUserProvider;
const useCurrentUser = () => {
    const context = (0, react_1.useContext)(UserContext);
    if (context === undefined) {
        throw new Error('useCurrentUser must be used within a UserProvider');
    }
    return context;
};
exports.useCurrentUser = useCurrentUser;
